import GenericValueComponent from './GenericValueComponent'
export default GenericValueComponent
